export default {
  401: 'Authorization failed',
  400: 'Parameter error',
  500: 'Service Error',
  101301: 'Http error',
  101401: 'Doc Error',
  101101: 'No studio, please create a studio',
  101102: 'Failed to update the game',
  101103: 'Failed to create game',
  101104: 'Failed to update user',
  101106: 'The game already exists',
  101107: 'Failed to generate game id and key',
  101108: 'Game authorization failed',
  101109: 'No permission to create games',
  101110: 'Game does not exist',
  101111: 'The user role to which the game belongs does not exist',
  101112: 'User does not have this game and studio permission',
  101601: 'Failed to create',
  101602: 'Failed to find read status',
  101603: 'Failed to read status update',
  101604: 'The number of messages exceeds the maximum limit',
  101201: 'Failed to update the basic information of the studio',
  101202: 'Failed to create member invitation record',
  101203: 'Invitation application already exists',
  101204: 'The studio does not exist',
  101205:
    'Invite the same person within 24 hours, multiple applications are not allowed',
  101206: 'Failed to update invitation time and username',
  101207:
    'Users who actively apply to join the studio will fail to simulate the call through the interface',
  101208: 'Failed to update approval status',
  101209: 'The new user failed to join the studio',
  101210:
    'Failed to obtain the gameid of the current administrator, or the current administrator does not belong to this studio',
  101211: 'Approval status flow error',
  101212: 'The current user is not owner permission',
  101213: 'User privilege elevation failed',
  101214: 'Failed to drop user privileges',
  101305: 'parameter error',
  101215: 'The current user cannot be removed',
  101216: 'Failed to remove user',
  101217: 'The user does not have this studio permission',
  101218: 'The member already exists in the studio',
  101219: 'The email inviting the user to join the studio failed to be sent',
  101220: 'Failed to store intermediate information',
  101221: 'The key for inviting users to join the studio by email is invalid',
  101222: 'The user invited to join the studio by email is inconsistent',
  101223: 'The key for inviting users to join the studio by email is invalid',
  101225: 'Email invitation to join the studio, the parameter is empty',
  101226: 'Already in the approval process',
  101227: 'owner can only remove current studio members',
  101228: 'Only the owner permission can remove the user',
  101229: 'You can only apply to join one studio',
  101230: 'No permission for this studio',
  101231: 'Update failed',
  101232: 'This user has already joined another studio',
  101233: 'Failed to create studio',
  101234: 'Created studio exceeds limit',
  101001: 'Failed to delete itself',
  101002: 'Failed to delete itself',
  101003: 'Failure to generate internal service registration key',
  101004: 'Failure to generate internal service registration address',
  101005: 'Request to generate registration link interface exception',
  101701: 'The creation of basic parameters is invalid',
  101702: 'Failed to create',
  101703: 'Find failed',
  101704: 'Failed to create',
  101705: 'Illegal creation',
  101801: 'Service creation failed',
  101802: 'The user has no game permissions',
  101803: 'The service is already enabled',
  101804: 'The current approval status is not pending',
  101805: 'Failed to activate the service',
  101806: 'Administrator approval application failed',
  101807: 'The service that has been opened, failed to close',
  101808: 'Service configuration update failed',
  /* prettier-ignore */
  101809: 'The user\'s application for opening the service failed',
  101810: 'Menu and service name conflict detected',
  101811: 'The service requested by the user does not exist',
  101812: 'Incomplete parameters, lack of approval page url',
  101813:
    'The current service is already under approval, please do not reapply',
  101814:
    'The service is being opened and created, and the service does not exist',
  101815: 'The services for this game are already opened!',
  101816:
    'The service is temporarily opened, compatible with online data, this game does not exist',
  101817:
    'Retry the failed synchronization permission, the failure record does not exist',
  101818:
    'Retry the permission of synchronization failure, the parsing records can not get the game id',
  101819:
    'Retry the permissions that failed to synchronize, there are exceptions in this batch of lists',
  101820: 'Retry the permissions that failed to sync, retry failed',
  101821: 'Retry synchronization failed permission, data update failed',
  101822:
    'Retry the failed synchronization permission, this record has been retried successfully',
  101823:
    'Retry the failed synchronization permission, the user uid cannot be empty',
  101824:
    'Failed to open and modify the status of the service, the status value is illegal',
  101825: 'The batch creation service approval failed',
  101826:
    'When InGame service is activated, service deployment must be done first',
  101846: 'The account is in arrears',
  101927:
    'The InGame service is activated, triggering deployment, but cannot be deployed',
  101928: 'InGame service opened, deployment failed',
  101929: 'Deployment failed, non-InGame services cannot be deployed',
  101930: 'Mail notification O&M failed',
  101901: 'The environment under the current game has the same name',
  101902: 'Environment creation failed',
  101903: 'Environment creation failed',
  101904:
    'The service id that needs to be opened is not in the registration service',
  101905:
    'It is not allowed to delete the environment created by the game by default',
  101906: 'The creation parameter is invalid',
  101917:
    'The creation parameters are invalid, and the id is not an open service',
  101918: 'Get the game environment does not exist',
  101919: 'Exceeded the maximum number of environment creation',
  102001: 'The environment under the current game has the same name',
  102002: 'Environment creation failed',
  102003: 'Failed to get configuration',
  102004: 'Failed to delete record',
  102005: 'Edit record not found',
  102006: 'Fail to edit',
  102007: 'Failed to query key configuration',
  102008: 'Query key invalid',
  102009: 'Query key invalid',
  102010: 'Failed to update configuration to redis',
  103201: 'Permission center verification interface exception',
  103202: 'Game does not exist',
  103203: 'Environment does not exist',
  103205: 'Parameter error',
  103206: 'Key parameter error',
  103207: 'GUID parameter error',
  103263:
    'You do not have permission for this operation. Please contact the studio administrator to obtain it.',
  103245: 'The user does not have this studio permission',
  103405: 'Submission failed, authentication information already exists',
  103430: 'Kpi Code entered incorrectly',
  101848: 'Incomplete enterprise certification',
  200001: 'Service exception',
  200002: 'Parameter exception',
  200003: 'Date formatting exception',
  200004: 'Invalid date',
  200005: 'Invalid studioId',
  103417: 'The enterprise has been certified',
  300000: 'Customer information accuracy verification failed',
  300001: 'Customer information accuracy verification failed',
  300006: 'Customer information accuracy verification failed',
  300004: 'Illegal ID number',
  102228:
    'The same environment already exists and is being recorded for approval or activation',
  101124: 'The title name already exists and cannot be created.',
  101265: 'The studio name already exists and cannot be created.',
  103402: 'Please do not resubmit during certification review',
  103433: 'Please do not resubmit during certification review',
  parameter_custom_error:
    'The value of parameter "{{parameter}}" as "{{errorValue}}" is invalid. Please check and try again.',
  parameter_expected: 'The expected value is "{{expectedValue}}".',
};
